import Vue from 'vue';
import store from '@/store';
import ModusignProxy from '@/proxies/ModusignProxy';
import * as types from './mutation-types';


let oldSearchCompanySeq = 0
let oldSearchYear = 0

/**
 * 계약서 리스트
 * @param commit
 * @param param
 */
export const findAll = ({ commit }, param) => {

  new ModusignProxy(param)
    .all()
    .then((response) => {
      commit(types.LIST, response);
    });

    // if(oldSearchCompanySeq !== param.searchCompanySeq || oldSearchYear !== param.searchYear) {
      store.dispatch('modusign/getStatus', param)
    // }  

    oldSearchCompanySeq = param.searchCompanySeq
    oldSearchYear = param.searchYear

};

/**
 * 계약서 삭제
 * @param commit
 * @param param
 */
export const deleteContract = ({ commit }, searchParam) => {
  new ModusignProxy()
    .destroy(searchParam.contractSeq)
    .then((response) => {
      if(response.header.returnCode === "OK") {
        store.dispatch('modusign/findAll', searchParam);
      } else {
        alert(response.header.resultMessages);
      }
    });
};


const getStatus = ({ commit }, searchParam) => {
  const param = {...searchParam}
  delete param.searchStatus

  new ModusignProxy(param)
  .getStatus(param.state)
  .then(response => {
    commit(types.STATUS, response )
  })

}


const embeddedView = ({ commit }, docId ) => {

  return new ModusignProxy()
  .embeddedView( docId )
  .then(response => response.data.embeddedUrl )

}

export default {
  findAll,
  deleteContract,
  getStatus,
  embeddedView
};
